export default "__VITE_ASSET__CwZJ_3s6__"